import React from 'react';
import {Link} from 'react-router-dom';
import './DashboardNewContract.scss';

const DashboardNewContract = (props) => {
  return (
  <section className="tips-box-section bg-blue-2" data-testid="DashboardBankDomiciliation" aria-labelledby="tips-box-title">
    <div className="container">
      <div className="tips-box__content">
        <div className="tips-box__content-container">
          <div className="tips-box__content-container-icon">
            <div className="tips-box__icon">
              <i className={props.icon}>
              <span className="path1"/><span className="path2"/></i>
            </div>
          </div>
          <div className="tips-box__content-container-text">
            <h2 className="tips-box__content-text--title headline-bold-fs3">{props.title}</h2>
            <p className="tips-box__content-text--description headline-fs6">{props.description}</p>
          </div>
        </div>
        <div className="tips-box__content-cta">
          <Link className="btn btn-secondary btn-icon btn-icon-right" to={props.link} aria-describedby="tips-box-title">
            {props.btnTitle}<span className="sr-only">{props.ctaSrOnly}</span>
            <i className="gc-icon-functional-arrow-right" aria-hidden="true"></i>
          </Link>
        </div>
      </div>
    </div>
  </section>
)
}

DashboardNewContract.propTypes = {};

export default DashboardNewContract;
